import { VesselScenario } from "src/interfaces/VesselScenario";

const getDataField = (data: VesselScenario, field: string) => {
  const fieldNodes = field.split('.');
  let finalObject = data;

  try {
    for (let i = 0; i < fieldNodes.length - 1; i++) {
      finalObject = finalObject[fieldNodes[i]];
    }
  }
  catch (error) {
    console.error(`Error accessing field ${field}:`, error);
    return undefined;
  }

  return finalObject;
};

// check out this beauty:
// const getField = (p, o) => p.reduce((xs, x) => (xs && xs[x] ? xs[x] : null), o);

export default getDataField;
